<template>
  <div class="main-space">
    <div class="main-title">会员配置</div>
    <div class="vip-desc">
      <div class="vip-desc-title">
        <img src="@/assets/images/info-circle-fill@2x.png" alt="" />
        <span>会员说明</span>
      </div>
      <div class="vip-desc-text">
        会员是所有权益集合，可制定规则用于不同用户端运营推广
      </div>
    </div>
    <div class="table-space">
      <el-table
        style="width: 100%"
        :data="formList"
        border
        size="small"
        :span-method="mergeLastTwoRows"
      >
        <el-table-column
          align="center"
          prop="name"
          label="会员名称"
          min-width="120"
        >
          <!-- <template slot-scope="scope">
            {{ scope.row.code_name || "-" }}
          </template> -->
        </el-table-column>
        <el-table-column
          align="center"
          prop="content"
          label="会员内容"
          min-width="260"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="rights"
          label="会员权益"
          min-width="260"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="rules"
          label="会员规则"
          min-width="260"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formList: [
        {
          name: "VIP",
          content: "VIP月会员、VIP半年会员、VIP年会员",
          rights: "数据导出、数据永久保存、血压健康周报",
          rules: "",
        },
        {
          name: "健康VIP会员",
          content: "健康VIP会员季度会员",
          rights: "微医问诊卡-季度",
          rules:
            "健康VIP会员和黄金VIP会员可在同一用户激活，优先消耗微医问诊卡-季度权益",
        },
        {
          name: "黄金VIP会员",
          content: "黄金VIP会员年会员",
          rights: "微医问诊卡-年度",
          rules:
            "健康VIP会员和黄金VIP会员可在同一用户激活，优先消耗微医问诊卡-季度权益",
        },
      ],
    };
  },
  methods: {
    mergeLastTwoRows({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        // 当行索引为1（第2行）时，合并2行
        if (rowIndex === 1) return [2, 1];
        // 当行索引为2（第3行）时，隐藏单元格
        if (rowIndex === 2) return [0, 0];
      }
    },
  },
};
</script>

<style scoped lang="less">
.main-space {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  height: 100%;
  border-radius: 4px;
  padding: 20px;
  box-sizing: border-box;
}
.main-title {
  font-weight: 600;
  font-size: 16px;
}
.vip-desc {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  background: #e8f3ff;
  border-radius: 2px;
  padding: 16px;
  box-sizing: border-box;
  .vip-desc-title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 6px;
    img {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
  .vip-desc-text {
    font-weight: 400;
    font-size: 14px;
    margin-left: 24px;
  }
}
.table-space {
  margin-top: 20px;
}
</style>
